import styled from "@emotion/styled";
import MUISkeleton from "@mui/material/Skeleton";
import isMobile from "src/helpers/isMobile";

const Skeleton = styled(MUISkeleton)``;

function ExamsShortViewSkeleton(props) {
	const renderSkeleton = () => {
		if (isMobile()) {
			return <Skeleton variant="rounded" height={130} />;
		}

		return (
			<>
				<Skeleton variant="rounded" height={75} />
				<Skeleton variant="rounded" height={75} />
				<Skeleton variant="rounded" height={75} />
			</>
		);
	};

	return <div className={props.className}>{renderSkeleton()}</div>;
}

export default styled(ExamsShortViewSkeleton)`
  ${Skeleton} {
    border-radius: 28px;
    margin-top: 8px;
  }
`;
